import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreeDotIcon = styled(UIIconButton).withConfig({
  displayName: "ThreeDotIconButton__ThreeDotIcon",
  componentId: "gnp2vn-0"
})(["&&{min-width:40px;height:20px;padding-top:9px;margin:15px 0 10px 0;border-radius:30px;}"]);
const defaultProps = {
  onClickHandler: () => {}
};
const ThreeDotIconButton = ({
  onClickHandler
}) => {
  return /*#__PURE__*/_jsx(ThreeDotIcon, {
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'conversations-thread-view.editors.previousMessageHistory.noEditsTooltip'
    }),
    size: "extra-small",
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "ellipses",
      size: "medium"
    })
  });
};
ThreeDotIconButton.displayName = 'ThreeDotIconButton';
ThreeDotIconButton.defaultProps = defaultProps;
export default ThreeDotIconButton;